// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3Ym9q","choiceBoxes":"toolbarselects_choiceBoxes__Qik_s","simpleField":"toolbarselects_simpleField__3_qmX"};